import React, { useState, useEffect } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { getSurveyAnalysisReport } from "../../Utils/adminFunctions";
import { toast } from "react-toastify";
import dataTableGrid from "../DataTableGrid";
let AdminListSurveyAnalysisReport = () => {
  const [listAnalysisReport, setListAnalysisReport] = useState("");
  useEffect(() => {
    manageanalysisreport();
  }, []);
  const manageanalysisreport = async () => {
    const response = await getSurveyAnalysisReport();
    if (response.status === "success" || response.status === "failure") {
      setListAnalysisReport(response.optionItems);
      dataTableGrid({
        data_table_id: "#analysis_reports",
        paginate: false,
        copy_option: [0, 1, 2, 3, 4, 5, 6],
        csv_option: [0, 1, 2, 3, 4, 5, 6],
        print_option: [0, 1, 2, 3, 4, 5, 6],
        sort_option: [7],
      });
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <table
                          id="analysis_reports"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>Survey Analysis Report ID</th>
                              <th>Survey ID</th>
                              <th>Survey Name</th>
                              <th>Participant Group ID</th>
                              <th>Created On</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{listAnalysisReport}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListSurveyAnalysisReport;
